import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit,
} from '@angular/core';
import { GenericService } from '../../services/generic.services/generic.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-loader',
  standalone: true,
  imports: [],
  templateUrl: './loader.component.html',
  styleUrl: './loader.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoaderComponent implements OnInit {
  constructor(
    private cd: ChangeDetectorRef,
    private dialogRef: MatDialogRef<LoaderComponent>,
    public gen: GenericService
  ) {}

  ngOnInit(): void {
    this.gen.loaderState.subscribe({
      next: (res) => {
        if (res === false) {
          this.dialogRef.close();
        }
        this.cd.markForCheck();
      },
    });
  }
}
